<script setup>
const props = defineProps({
  name: {
    type: String,
    default: 'switch'
  },
  options: {
    type: Array,
    default: () => []
  },
  selectedValue: {
    type: [Array, String],
    default: undefined
  },
  optionLabel: {
    type: String,
    default: 'label'
  },
  optionValue: {
    type: String,
    default: 'value'
  }
})
const emit = defineEmits(['onChange'])

const handleChange = option => {
  emit('onChange', option[props.optionValue])
}

const isSelected = option => {
  if (!props.selectedValue) return false
  return (
    JSON.stringify(option[props.optionValue]) ===
    JSON.stringify(props.selectedValue)
  )
}
</script>

<template>
  <div class="switch-button">
    <label
      v-for="option in options"
      :key="option[optionLabel]"
      :for="option[optionLabel]"
      :aria-selected="isSelected(option)"
    >
      {{ option[optionLabel] }}
      <input
        :id="option[optionLabel]"
        :name="name"
        type="radio"
        :checked="isSelected(option)"
        @change="handleChange(option)"
      />
    </label>
  </div>
</template>

<style lang="scss" scoped>
.switch-button {
  display: flex;
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-30);
  border-radius: var(--gl-border-radius-lg);
  background-color: var(--gl-color-shades-gray-10);
  color: var(--gl-color-shades-gray-70);
  font-size: var(--gl-font-size-xs);

  label {
    padding: var(--gl-spacing-02) var(--gl-spacing-04);
    font-weight: var(--gl-font-weight-regular);
    cursor: pointer;

    &[aria-selected='true'] {
      background-color: var(--gl-color-shades-white);
      border-radius: var(--gl-border-radius-lg);
      color: var(--gl-color-shades-magenta-60);
    }
  }

  input {
    margin: 0;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
  }
}
</style>
